import _ from "lodash";
import React from "react";
import { useSelector } from "react-redux";
import { ReportsState } from "../../redux/models/reports";
import { State } from "../../redux/reducers/root";
import { doctorOfficeSelector } from "../../redux/selectors/doctor_office";
import { Link } from "react-router-dom";

interface Props extends React.PropsWithChildren {
  doctorId: number;
  title: string;
  icon: string;
  link: string;
  color: string;
  className?: string;
  description_ltr?: boolean;
  noArrow?: boolean;
}
const BiddingHistory: React.FC<Props> = ({
  doctorId,
  className,
  title,
  icon,
  link,
  color,
  description_ltr,
  noArrow = false,
  children,
}) => {
  const DAY_COUNT = 30;
  const reports = useSelector((state: State) => state.reports);
  const offices = useSelector((state: State) => doctorOfficeSelector(state, doctorId));
  const office_ids = offices.map((office) => office.id);
  const firstOffice = offices?.[0];
  const doctor_report: ReportsState = _.pickBy(reports, (value, key: string) => office_ids?.includes(parseInt(key)));
  const visits = doctor_report[firstOffice?.id]?.pageVisits?.data
    ?.slice(-DAY_COUNT)
    .reduce((acc, i) => acc + i.count, 0);
  const visitCountText = visits > 0 ? `${visits} ‌بازدید` : "بدون بازدید";

  return (
    <Link to={link} className={`bg-white rounded-md mt-6 shadow ${className}`}>
      <div className="flex items-center px-4 py-2">
        <div className={`flex mx-auto  items-center justify-center  bg-pkc-${color}-15 btn-circle `}>
          <i className={`${icon}  my-auto text-pkc-${color}`} />
        </div>
        <div className="flex flex-col justify-center flex-1 pr-3 mr-auto">
          <p className={`mt-2 font-bold text-sm pb-2 text-pkc-${color}`}>{title}</p>
          <p
            style={{ direction: description_ltr ? "ltr" : "rtl" }}
            className="text-xs font-medium text-right text-gray-600 sm:text-sm"
          >
            <span className="text-sm">{visitCountText}</span>
          </p>
        </div>
        {!noArrow && (
          <div className="flex items-center text-xs font-medium text-gray-600 hover:text-pkc-telegram-blue ">
            <div className="ml-3 ">نمودار بازدیدها</div>
            <i className="my-auto fas fa-chevron-left" />
          </div>
        )}
      </div>
      {children}
    </Link>
  );
};

export default BiddingHistory;
